import { BasePath } from '@constants/Auth';
import { t, Trans } from '@lingui/macro';
import { Box, Card, Checkbox, Grid, Typography, useMediaQuery, useTheme } from '@material-ui/core';
import { HighlightOffOutlined, ScheduleOutlined } from '@material-ui/icons';
import { colors, SwyftModal } from '@swyft/ui';

const welcomeData = [
  {
    src: `${BasePath}/assets/FAQ-CreateQuestionnaire.png`,
    title: t`Create your first questionnaire`,
    link: 'https://www.pipelyne.com/create-questionnaire'
  },
  {
    src: `${BasePath}/assets/FAQ-CreateProducts.png`,
    title: t`Adding a contact form to your questionnaire`,
    link: 'https://www.pipelyne.com/add-contact-form'
  },
  {
    src: `${BasePath}/assets/FAQ-AddProducts.png`,
    title: t`Different types of questions to ask`,
    link: 'https://www.pipelyne.com/question-types'
  },
  {
    src: `${BasePath}/assets/FAQ-Publish.png`,
    title: t`Publishing the questionnaire`,
    link: 'https://www.pipelyne.com/publish-questionnaire'
  }
];

export const WelcomeModal = ({
  open,
  noShowAgain,
  handleClose,
  setNoShowAgain
}: {
  open: boolean;
  noShowAgain: boolean;
  handleClose: () => void;
  setNoShowAgain: (noShowAgain: boolean) => void;
}) => {
  const theme = useTheme();
  const isLgDown = useMediaQuery(theme.breakpoints.down('lg'));

  return (
    <SwyftModal
      open={open}
      onClose={() => {
        handleClose();
      }}
      showCloseButton={false}
      modalStyle='small'
      width={1274}
      maxWidth={isLgDown ? '80%' : '75%'}
    >
      <Box>
        <Box display='flex' justifyContent='space-between'>
          <Typography variant='h5' color='secondary'>
            <Trans>Welcome</Trans>
          </Typography>
          <HighlightOffOutlined color='primary' className='cursor-pointer' onClick={handleClose} fontSize='large' />
        </Box>
        <Box my={1}>
          <Typography color='secondary'>
            <Trans>Get to know Pipelyne</Trans>
          </Typography>
        </Box>
        <Typography variant='subtitle2'>
          <Trans>
            Here you can learn about Pipleyne’s tools and techniques with our Get Started series, which will <br />
            help you to familiarise yourself with the workspace and how to create and publish your work.
          </Trans>
        </Typography>
        <Box width={isLgDown ? '90%' : '80%'} m='auto' my={4}>
          <Grid container spacing={isLgDown ? 3 : 4}>
            {welcomeData.map((item, index) => (
              <Grid item xs={3} key={index}>
                <CardElement title={item.title} src={item.src} link={item.link} />
              </Grid>
            ))}
          </Grid>
        </Box>
        <Box mt={1}>
          <Typography variant='caption'>
            <Trans>View all tutorials to help you build, customise and publish your questionnaire in minutes. </Trans>
          </Typography>
          <Box px={2} mb={1}>
            <a href='https://www.pipelyne.com/faq' target='_blank' rel='noreferrer'>
              <Typography variant='body2' color='primary'>
                <Trans>View All</Trans>
              </Typography>
            </a>
          </Box>
        </Box>
        <Box display={'flex'} alignItems={'center'}>
          <Checkbox checked={noShowAgain} color='primary' onChange={(e) => setNoShowAgain(e.target.checked)} />
          <Typography variant='subtitle2'>
            <Trans>Dont show this at startup</Trans>
          </Typography>
        </Box>
      </Box>
    </SwyftModal>
  );
};

const CardElement = ({ title, src, link }: { title: string; src: string; link: string }) => {
  return (
    <Card variant='outlined' className='px-4 pb-2 h-full flex flex-col'>
      <img src={src} />
      <Box mb={4} mt={1}>
        <Typography variant='subtitle2' className='semiBold'>
          {title}
        </Typography>
      </Box>
      <Box mt='auto' display='flex' justifyContent='space-between'>
        <a href={link} target='_blank' rel='noreferrer'>
          <Typography variant='body2' color='primary'>
            <Trans>View</Trans>
          </Typography>
        </a>
        <Box>
          <ScheduleOutlined style={{ color: colors.grey[300], fontSize: 16 }} className='mr-1' />
          <Typography variant='caption' className='labelText'>
            2m
          </Typography>
        </Box>
      </Box>
    </Card>
  );
};
